import { render, staticRenderFns } from "./AssignCompanyTable.vue?vue&type=template&id=3fd7f604&scoped=true&"
import script from "./AssignCompanyTable.vue?vue&type=script&lang=js&"
export * from "./AssignCompanyTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3fd7f604",
  null
  
)

export default component.exports